import React from "react"
import { observer } from "mobx-react-lite"

import { useStore } from "@store"
import DocumentIcon from "@components/ui/Icon/DocumentIcon"
import { MANUAL_UPLOAD_FILE_STATUS } from "@framework/types/content-manager"
import ProgressBar from "@components/ui/ProgressBar/ProgressBar"
import { getFileIcon, getUniqueNameForFile } from "@utils/file"
import ErrorChip from "@components/ui/ErrorChip/ErrorChip"

import styles from "./ContentManagerUploadFormModal.module.sass"

type SelectedFileProps = {
  file: File
  contentType?: string
}

const SelectedFile: React.FC<SelectedFileProps> = observer(
  ({ file, contentType }) => {
    const { contentManagerStore } = useStore()
    const upload = contentManagerStore.uploads[getUniqueNameForFile(file)]
    const success = upload?.status === MANUAL_UPLOAD_FILE_STATUS.COMPLETED
    const failed = upload?.status === MANUAL_UPLOAD_FILE_STATUS.FAILED
    const errorMessage = upload?.error?.trim()

    return (
      <div className={styles.selectedFile} key={file.webkitRelativePath}>
        <DocumentIcon icon={getFileIcon(file)} />
        <div className={styles.fileUploadStatus}>
          <ProgressBar
            variant="candy"
            value={success ? 100 : failed ? 100 : upload?.progress ?? 0}
            label={`${file.name} ${contentType ? `(${contentType})` : ""}`}
            isDone={success}
            color="primary"
            progress={
              failed ? (
                <ErrorChip
                  message={errorMessage || "Upload failed"}
                  messagePlacement="left"
                />
              ) : null
            }
          />
          {failed && errorMessage ? (
            <div className={styles.uploadErrorMessage} title={errorMessage}>
              {errorMessage}
            </div>
          ) : null}
        </div>
      </div>
    )
  }
)

export default SelectedFile
